'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

/**
 * 2026-07-07 (Leon feedback) — brand footer, mirrors the one on the
 * landing page (`apps/web/app/page.tsx:415`). Rendered inside the
 * WorkspaceLayout so authenticated pages carry the same footprint as
 * the public marketing shell (copyright, tagline, privacy / terms).
 *
 * Hidden on `/studio/train` — the training page uses a full-viewport
 * two-pane flex layout where a bottom footer would either compete for
 * vertical space (SessionPanel needs every px) or force an outer
 * scroll that pushes the transcript up. Every other product surface
 * (overview / vault / settings / studio / launch / test-chat /
 * platform) is natural doc flow and welcomes it.
 */
export function SiteFooter() {
  const pathname = usePathname() ?? '';
  const hide =
    pathname === '/studio/train' ||
    pathname.startsWith('/studio/train/') ||
    // Also hide inside the studio Tiptap editor + the test-chat surface
    // — both use full-viewport flex layouts.
    pathname.startsWith('/studio/writing/') ||
    pathname.startsWith('/studio/test-chat');
  if (hide) return null;
  return (
    <footer className="border-t border-[rgba(26,34,56,0.06)] py-6 mt-12 bg-[#F2EBDC]">
      <div className="max-w-[1200px] mx-auto px-5 sm:px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-3 text-center md:text-left">
        <p className="font-serif text-[13px] md:text-[14px] text-[#6B6757]">
          © 2026 ChiefEco AI{' '}
          <em className="not-italic text-[#8F8975]">· 为 AI 时代的专家智识而生</em>
        </p>
        <nav className="flex items-center gap-5 font-mono text-[10.5px] md:text-[11px] tracking-[0.18em] uppercase text-[#6B6757]">
          <Link href="/privacy" className="hover:text-[#A07E3A] transition">
            隐私政策
          </Link>
          <Link href="/terms" className="hover:text-[#A07E3A] transition">
            服务条款
          </Link>
        </nav>
      </div>
    </footer>
  );
}
